import { motion } from 'framer-motion';
import FadeIn from '../Motion/FadeIn.js';
import './SectionHeading.sass';

function SectionHeading({ text, eyebrow }) {
  return (
    <FadeIn className="sectionheading_parent">
      {eyebrow && <div className="sectionheading_eyebrow fs1">{eyebrow}</div>}
      <div className="sectionheading_text fs3">{text}</div>
      <motion.div
        className="sectionheading_underline"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
      />
    </FadeIn>
  );
}

export default SectionHeading;
